// About.jsx
import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/esm/FormGroup';
import { useForm, Controller } from "react-hook-form";
import { Link } from 'react-router-dom'

/*const About = () => {
    return (
        <div>
            This is about page
        </div>
    )
}

export default About
*/

export default function About() {
    return (
        <>
        <Container fluid className='p-0 bg-body-tertiary'>
            <PageHeader></PageHeader>
            <TicketType pageTitle="Ticket Type" />
        </Container>
        </>
    );
}

export function PageHeader() {
    return (
    <>
        <Navbar expand="lg" className="bg-body-secondary">
        <Container>
            <Navbar.Brand href="#home">Ticket Manager</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link href="#home">Home</Nav.Link>
                <Nav.Link href="#link">Link</Nav.Link>
                
            </Nav>
            </Navbar.Collapse>
        </Container>
        </Navbar>
    </>
    )        

}

export function WebPImageComponent () {
    return (
      <div>
        <img src={require('./PAD.webp')} style={{width:'100%'}}/>
      </div>
    );
  };
  
export function TicketType({pageTitle}) {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        control
      } = useForm();
    
    const [message, setMessage] = useState("");

    console.log(errors);

    return (
        <Container className='p-4'>
            <Row className='mt-2'>
                <Col className='text-center'>
                    <h1>{pageTitle}</h1>
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col className='text-center'>
                    <WebPImageComponent></WebPImageComponent>
                </Col>
            </Row>

            <Form onSubmit={handleSubmit((data) => {
                fetch("https://fzily2w2rbkp6qcniwennj6egq.apigateway.ca-toronto-1.oci.customer-oci.com/blair-starter/blair-app/tickets?id=21", )
                .then((res) => console.log(res.json()))
                .then((data) => setMessage(data.message));
                console.log(data)
                
                //var payload = {'name':'test ticket','description':'this is a test ticket','price':'299'};
                
                /*fetch('http://localhost:8000/maves/shares', {
                    method: 'POST',
                    headers: {
                        Authorization: 'Bearer abcdxyz',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload)
                  }).then((res) => {
                    if (res.ok) {
                      return res.json()
                    }
                
                    throw new Error(res.responseText);
                
                  })
                  .then((data) => console.log(data))
                  .catch((err) => console.log(err))*/


                })
                }>

                <Form.Group>
                    <Form.Label>Ticket Name:</Form.Label>
                    <Form.Control type='text' placeholder='ie: Adult, General Admisstion, etc.' 
                        {...register("ticketName", 
                        {required:"Please enter a ticket type name"})
                        }>
                    </Form.Control>
                    <p className='error'>{errors.ticketName?.message}</p>
                    
                    <Form.Label>Description:</Form.Label><br></br>
                    <Form.Control as='textarea' rows={3} {...register("ticketDescription", 
                        {required:"Please enter a description for this type of ticket"})
                        }/>
                    <p className='error'>{errors.ticketDescription?.message}</p>

                    <Form.Label>Base Price:</Form.Label><br></br>
                    <Form.Control type='text' placeholder='$$$' {...register("ticketPrice", 
                        {required:"Please enter a price for this ticket"})
                        }></Form.Control>
                    <p className='error'>{errors.ticketPrice?.message}</p>

                    <Form.Label>Price Type:</Form.Label><br></br>
                    <Form.Select {...register("ticketPriceType", 
                        {required:"Please enter a price type for this ticket"})
                        }>
                        <option value="someOption">Per Ticket</option>
                        <option value="otherOption">Percentage</option>
                    </Form.Select>
                    <p className='error'>{errors.ticketPriceType?.message}</p>

                        <Form.Label>Ticket Type:</Form.Label><br></br>
                        <Form.Select {...register("ticketType", 
                        {required:"Please enter a type of ticket"})
                        }>
                            <option value="someOption1">Standard</option>
                            <option value="otherOption1">Add On</option>
                            <option value="otherOption2">Product</option>
                        </Form.Select>
                        <p className='error'>{errors.ticketType?.message}</p>


                </Form.Group>
                <Button type="submit">Submit form</Button>
            </Form>
        </Container>
   );
}

/*        <Container className='p-4'>
            <Row className='mt-2'>
                <Col className='text-center'>
                    <h1>{pageTitle}</h1>
                </Col>
            </Row>
            <Form>
                <Form.Group>
                    <Form.Label>Ticket Name:</Form.Label>
                    <Form.Control type='text' placeholder='ie: Adult, General Admisstion, etc.'></Form.Control>

                    <Form.Label>Description:</Form.Label><br></br>
                    <Form.Control as='textarea' rows={3}/>

                    <Form.Label>Base Price:</Form.Label><br></br>
                    <Form.Control type='text' placeholder='$$$'></Form.Control>

                    <Form.Label>Price Type:</Form.Label><br></br>
                    <Form.Select>
                        <option value="someOption">Per Ticket</option>
                        <option value="otherOption">Percentage</option>
                    </Form.Select>

                        <Form.Label>Ticket Type:</Form.Label><br></br>
                        <Form.Select>
                            <option value="someOption1">Standard</option>
                            <option value="otherOption1">Add On</option>
                            <option value="otherOption2">Product</option>
                        </Form.Select>

                </Form.Group>
                <Button type="submit">Submit form</Button>
            </Form>
        </Container>
    */
